import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../redux/store";
import { setInteractionId } from "../redux/reducer";
import apiClient from "./api";

interface AddInteractionArguments {
  name: string;
  context: {};
}

export const useSaveInteraction = () => {
  const interactionId = useSelector((state: RootState) => state.interactionId);
  const dispatch = useDispatch();

  const saveInteraction = useCallback(
    async (args: AddInteractionArguments) => {
      const timestamp = Date.now().toString();
      const action = {
        name: args.name,
        timestamp: timestamp,
        context: args.context,
      };

      try {
        if (interactionId) {
          await apiClient.interactionControllerAddInteractionAction({
            addInteractionActionRequest: {
              interactionId: interactionId,
              action: action,
            },
          });
          console.log("Interaction saved successfully");
        } else {
          const res = await apiClient.interactionControllerAddInteraction({
            addInteractionRequest: {
              action: action,
            },
          });
          console.log("res", res);
          if (res.interactionId) {
            dispatch(setInteractionId(res.interactionId));
            console.log("Interaction saved successfully");
          } else {
            console.log("Interaction saved failed");
          }
        }
      } catch (error) {
        console.error("Error saving interaction:", error);
      }
    },
    [dispatch, interactionId]
  );

  return { saveInteraction };
};
